import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {SurveyService} from "./services/survey.service";
import {HeaderComponent} from "./components/header/header.component";

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, HeaderComponent],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
	constructor(private surveyService:SurveyService) {
	}

	ngOnInit():void {
		this.surveyService.init();
	}
}
